export const MenuData = [
    {
        title: 'Home',
        url:"/",
        cName:"nav-links",
        icon:"fa-solid  fa-house-user"
    },

    {
        title: 'Contact Admin',
        url:"mailto:janwry.delacruz@tup.edu.ph",
        cName:"nav-links",
        icon:"fa-solid  fa-question-circle"
    },

   
]